import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { IIconProperty } from 'types/iconProps';

const People = ({ width, height, color }: IIconProperty) => {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox="0 0 60 60"
      style={{ transform: 'scale(1)', width, height }}
    >
      <path
        d="M43.8246 19.425C43.6496 19.4 43.4746 19.4 43.2996 19.425C39.4246 19.3 36.3496 16.125 36.3496 12.225C36.3496 8.25 39.5746 5 43.5746 5C47.5496 5 50.7996 8.225 50.7996 12.225C50.7746 16.125 47.6996 19.3 43.8246 19.425Z"
        fill="#BDBDBB"
      />
      <path
        d="M51.975 36.751C49.175 38.626 45.25 39.326 41.625 38.851C42.575 36.801 43.075 34.526 43.1 32.126C43.1 29.626 42.55 27.251 41.5 25.176C45.2 24.676 49.125 25.376 51.95 27.251C55.9 29.851 55.9 34.126 51.975 36.751Z"
        fill="#BDBDBB"
      />
      <path
        d="M16.1004 19.425C16.2754 19.4 16.4504 19.4 16.6254 19.425C20.5004 19.3 23.5754 16.125 23.5754 12.225C23.5754 8.225 20.3504 5 16.3504 5C12.3754 5 9.15039 8.225 9.15039 12.225C9.15039 16.125 12.2254 19.3 16.1004 19.425Z"
        fill="#BDBDBB"
      />
      <path
        d="M16.3748 32.1265C16.3748 34.5515 16.8998 36.8515 17.8498 38.9265C14.3248 39.3015 10.6498 38.5515 7.94981 36.7765C3.9998 34.1515 3.9998 29.8765 7.94981 27.2515C10.6248 25.4515 14.3998 24.7265 17.9498 25.1265C16.9248 27.2265 16.3748 29.6015 16.3748 32.1265Z"
        fill="#BDBDBB"
      />
      <path
        d="M30.3 39.675C30.1 39.65 29.875 39.65 29.65 39.675C25.05 39.525 21.375 35.75 21.375 31.1C21.4 26.35 25.225 22.5 30 22.5C34.75 22.5 38.6 26.35 38.6 31.1C38.575 35.75 34.925 39.525 30.3 39.675Z"
        fill="#BDBDBB"
      />
      <path
        d="M22.175 44.8516C18.4 47.3766 18.4 51.5266 22.175 54.0266C26.475 56.9016 33.525 56.9016 37.825 54.0266C41.6 51.5016 41.6 47.3516 37.825 44.8516C33.55 41.9766 26.5 41.9766 22.175 44.8516Z"
        fill="#BDBDBB"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3131_49144"
          x1="36.3496"
          y1="12.2125"
          x2="50.7996"
          y2="12.2125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3131_49144"
          x1="41.5"
          y1="32.0073"
          x2="54.9156"
          y2="32.0073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3131_49144"
          x1="9.15039"
          y1="12.2125"
          x2="23.5754"
          y2="12.2125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3131_49144"
          x1="4.9873"
          y1="32.0201"
          x2="17.9498"
          y2="32.0201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3131_49144"
          x1="21.375"
          y1="31.0875"
          x2="38.6"
          y2="31.0875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3131_49144"
          x1="19.3437"
          y1="49.4391"
          x2="40.6562"
          y2="49.4391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC02D" />
          <stop offset="1" stopColor="#FACF66" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default People;
